import { render, staticRenderFns } from "./InpatientServices.vue?vue&type=template&id=2a86199a&scoped=true"
import script from "./InpatientServices.vue?vue&type=script&lang=js"
export * from "./InpatientServices.vue?vue&type=script&lang=js"
import style0 from "./InpatientServices.vue?vue&type=style&index=0&id=2a86199a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a86199a",
  null
  
)

export default component.exports